import React from 'react';
import { Link } from 'react-router-dom';
import Wrapper from "./Wrapper";

function Error404() {
    return (
        <Wrapper>
            <div className="min-h-screen flex flex-col items-center justify-center bg-slate-600 px-4">
                <h1 className="text-9xl font-extrabold text-gray-300 tracking-widest">
                    404
                </h1>
                <div className="bg-black px-2 text-sm text-white rounded rotate-12 absolute">
                    Page Not Found
                </div>
                <div className="mt-5 text-center">
                    <p className="text-lg text-gray-600 mb-4">
                        It looks like you’ve landed in the wrong place.
                    </p>
                    <Link
                        to="/"
                        className="inline-block px-6 py-3 bg-black text-white text-sm font-medium rounded-md shadow hover:bg-gray-800 transition"
                    >
                        Go to Home
                    </Link>
                </div>
            </div>
        </Wrapper>
    );
}

export default Error404;
